import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const GradientAreaChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={200}>
    <AreaChart data={data}>
      <defs>
        <linearGradient id="gradientFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#3b6bd6" stopOpacity={0.8} />
          <stop offset="95%" stopColor="#3b6bd6" stopOpacity={0.1} />
        </linearGradient>
      </defs>
      <XAxis dataKey="name" hide />
      <YAxis hide />
      <Tooltip />
      <Area
        type="monotone"
        dataKey="value"
        stroke="#3b6bd6"
        fill="url(#gradientFill)"
      />
    </AreaChart>
  </ResponsiveContainer>
);

export default GradientAreaChart;
